export default __webpack_public_path__ + "static/media/Grupo 21@2x.6de1295a.png";